const fetcher = async (url, options = { cache: "no-cache" }) => {
  const rawUrl = String(url || "").trim();
  if (!rawUrl) throw new Error("Invalid URL");
  if (/^(javascript|data|vbscript):/i.test(rawUrl)) {
    throw new Error("Blocked unsafe URL scheme");
  }

  const res = await fetch(rawUrl, options);

  if (!res.ok) {
    const error = new Error("An error occurred while fetching the data.");
    error.info = await res.json();
    error.status = res.status;
    return {
      notFound: true,
    };
    throw error;
  }
  return res.json();
};

export default fetcher;
